export default __webpack_public_path__ + "static/media/congrats-mobile.d17e7d29.svg";